export default __webpack_public_path__ + "static/media/about_vector.c42fe3db.png";